<template>
  <div class="completedProcessing common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">线索ID：</div>
          <div class="content">
            <el-input v-model="form.leadId" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">客户单位：</div>
          <div class="content">
            <el-input v-model="form.unit" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">活动名称：</div>
          <div class="content">
            <el-input v-model="form.activityName" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">客户姓名：</div>
          <div class="content">
            <el-input v-model="form.customerName" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">联系电话：</div>
          <div class="content">
            <el-input v-model="form.phone" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">线索分类：</div>
          <div class="content">
            <el-select v-model="form.leadTypeCode" clearable placeholder="请选择">
              <el-option
                v-for="item in leadTypeOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">线索反馈结果：</div>
          <div class="content">
            <el-select v-model="form.feedbackResultCode" clearable placeholder="请选择">
              <el-option
                v-for="item in feedbackResultOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">私海池：</div>
          <div class="content">
            <el-select
              v-model="form.poolId"
              clearable
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="poolLoading"
            >
              <el-option v-for="(item, index) in poolOptions" :key="index" :label="item.value" :value="item.key" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">线索状态：</div>
          <div class="content">
            <el-select v-model="form.poolStat" clearable placeholder="请选择">
              <el-option
                v-for="item in leadStatOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">线索上传时间：</div>
          <div class="content">
            <el-date-picker
              v-model="form.time"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
            />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">线索来源：</div>
          <div class="content">
            <el-select v-model="form.leadSourceCode" clearable placeholder="请选择">
              <el-option
                v-for="item in leadSourceOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
      <div class="advancedSearchBtn">
        <span :class="searchOpenFlag ? 'open' : ''" @click="searchOpenFlag = !searchOpenFlag">
          <span>{{ searchOpenFlag ? '收起搜索' : '高级搜索' }}</span>
          <i class="iconfont icon-rili4-icon" />
        </span>
      </div>
    </div>
    <commonTable ref="completedProcessingTable" />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import { cluePoolListApi } from '../cluePool/service';

export default {
  name: 'CompletedProcessing',
  data () {
    return {
      form: {
        poolType: '2',
        poolConfigType: 'privateSeaDone'
      },
      tempForm: {
        poolType: '2',
        poolConfigType: 'privateSeaDone'
      },
      leadTypeOptions: [],
      feedbackResultOptions: [],
      poolOptions: [],
      leadStatOptions: [],
      leadSourceOptions: [],
      poolLoading: false,
      searchOpenFlag: false
    };
  },
  components: {
    commonTable
  },
  methods: {
    remoteMethod (query) {
      this.poolLoading = true;
      cluePoolListApi.getPoolOptionList(2, query).then(res => {
        if (res.status === '200') {
          if (res.data && res.data.length > 0) {
            this.poolOptions = res.data;
          } else {
            this.poolOptions = [];
          }
        }
        this.poolLoading = false;
      });
    },
    detailsJump (row) {
      this.$router.push({
        path: '/clueDetails',
        query: {
          leadId: row.leadId,
          metaActive: '/completedProcessing'
        }
      });
    },
    reset () {
      this.form = {
        poolType: '2',
        poolConfigType: 'privateSeaDone'
      };
      this.searchBtn();
    },
    searchBtn () {
      this.tempForm = JSON.parse(JSON.stringify(this.form));
      if (this.tempForm.time) {
        this.tempForm.startTime = this.form.time[0].format('yyyy-MM-dd');
        this.tempForm.endTime = this.form.time[1].format('yyyy-MM-dd');
        delete this.tempForm.time;
      }
      if (this.tempForm.time === null) {
        delete this.tempForm.time;
      }
      this.$refs.completedProcessingTable.pageData.pageNum = 1;
      this.$refs.completedProcessingTable.getTableData({ url: '/lead/lead/list/condition', params: this.tempForm });
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('线索ID')
          ._width('120')
          ._fixed('left')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <span class="btnText" onClick={() => { this.detailsJump(row); }}>{ row.leadId }</span>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('客户单位')
          ._width('8%')
          ._data('unit')
      );
      tableRow.push(
        new TableColumns()
          ._title('联系电话')
          ._width('9%')
          ._data('phone')
      );
      tableRow.push(
        new TableColumns()
          ._title('客户姓名')
          ._width('8%')
          ._data('name')
      );
      tableRow.push(
        new TableColumns()
          ._title('城市')
          ._width('6%')
          ._data('city')
      );
      tableRow.push(
        new TableColumns()
          ._title('行业')
          ._width('6%')
          ._data('industry')
      );
      tableRow.push(
        new TableColumns()
          ._title('产品线')
          ._width('8%')
          ._data('productLine')
      );
      // tableRow.push(
      //   new TableColumns()
      //     ._title('线索分类')
      //     ._width('8%')
      //     ._data('leadTypeName')
      // );
      // tableRow.push(
      //   new TableColumns()
      //     ._title('活动编号')
      //     ._width('8%')
      //     ._data('activityCode')
      // );
      // tableRow.push(
      //   new TableColumns()
      //     ._title('活动分类')
      //     ._width('8%')
      //     ._data('activityClassificationName')
      // );
      // tableRow.push(
      //   new TableColumns()
      //     ._title('活动名称')
      //     ._width('8%')
      //     ._data('activityName')
      // );
      // tableRow.push(
      //   new TableColumns()
      //     ._title('实际线索等级')
      //     ._width('8%')
      //     ._data('classificationActualName')
      // );
      tableRow.push(
        new TableColumns()
          ._title('线索上传日期')
          ._width('10%')
          ._data('uploadTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = row[column.property] ? new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd') : '';
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('备注')
          ._width('8%')
          ._data('remark')
          ._offOverFlow(true)
      );
      tableRow.push(
        new TableColumns()
          ._title('线索状态')
          ._width('8%')
          ._data('statName')
      );
      tableRow.push(
        new TableColumns()
          ._title('当前节点')
          ._width('8%')
          ._data('nodeName')
      );
      tableRow.push(
        new TableColumns()
          ._title('线索反馈结果')
          ._width('8%')
          ._data('feedbackResultName')
      );
      let column = tableRow._cols();
      this.$refs.completedProcessingTable.setColumn(column);
      this.$refs.completedProcessingTable.loadTable({ url: '/lead/lead/list/condition', listKey: 'list', params: this.form });
    },
    getOptionsList () {
      cluePoolListApi.getOptionsList('PRIVATE_SEA_DONE').then(res => {
        if (res.status === '200') {
          this.leadTypeOptions = res.data.leadTypeOptions;
          this.feedbackResultOptions = res.data.feedbackResultOptions;
          this.leadStatOptions = res.data.leadStatOptions;
          this.leadSourceOptions = res.data.leadSourceOptions;
        }
      });
    }
  },
  activated () {
    this.$refs.completedProcessingTable.getTableData({ url: '/lead/lead/list/condition', listKey: 'list', params: this.tempForm });
  },
  mounted () {
    this.getOptionsList();
    this.loadTable();
    this.remoteMethod('');
  }
};
</script>

<style scoped>

</style>
